import { render, staticRenderFns } from "./appGorupForm.vue?vue&type=template&id=1f205e6a&scoped=true"
import script from "./appGorupForm.vue?vue&type=script&lang=js"
export * from "./appGorupForm.vue?vue&type=script&lang=js"
import style0 from "./appGorupForm.vue?vue&type=style&index=0&id=1f205e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f205e6a",
  null
  
)

export default component.exports